import { App } from "antd";

let _notification = null;
let _modal = null;

/**
 * Mount this component inside each <App> (top-level and inside each portal
 * ConfigProvider) so that notification/modal instances are always themed.
 */
export function AntdStaticHelper() {
  const { notification, modal } = App.useApp();
  _notification = notification;
  _modal = modal;
  return null;
}

const DURATION  = 4;
const PLACEMENT = "topRight";

export const toast = {
  success: (message, description) =>
    _notification?.success({ message: message ?? "Éxito",       description, duration: DURATION, placement: PLACEMENT }),
  warning: (message, description) =>
    _notification?.warning({ message: message ?? "Advertencia", description, duration: DURATION, placement: PLACEMENT }),
  error: (message, description) =>
    _notification?.error({ message:   message ?? "Error",       description, duration: DURATION, placement: PLACEMENT }),
  info: (message, description) =>
    _notification?.info({ message:    message ?? "Información", description, duration: DURATION, placement: PLACEMENT }),
};

export const modal = {
  confirm: (props) => _modal?.confirm(props),
  warning: (props) => _modal?.warning(props),
  info:    (props) => _modal?.info(props),
  error:   (props) => _modal?.error(props),
  success: (props) => _modal?.success(props),
};
